import { Timeline, Group, Badge, Stack, ScrollArea } from "@mantine/core";
import { ThoughtProcessData } from "../types";
import { CodeHighlight } from "@mantine/code-highlight";
import { TokenUsageGraph } from "../analysis/TokenUsageGraph";

export interface ThoughtProcessProps {
    data: ThoughtProcessData[];
}

export const ThoughtProcess = ({ data }: ThoughtProcessProps) => {
    return (
        <Timeline bulletSize={20} lineWidth={3}>
            {data.map((t, index) => (
                <Timeline.Item title={t.title} key={index}>
                    <Stack gap="md">
                        {t.props && (
                            <Group gap="xs">
                                {(Object.keys(t.props).filter(k => k !== "token_usage" && k !== "query_plan") || []).map((k: any) => (
                                    <Badge variant="light" color="blue" size="lg" radius="sm">
                                        {k}: {JSON.stringify(t.props?.[k])}
                                    </Badge>
                                ))}
                            </Group>
                        )}
                        {t.props?.token_usage && <TokenUsageGraph tokenUsage={t.props.token_usage} reasoningEffort={t.props.reasoning_effort} />}
                        <ScrollArea.Autosize mah={400}>
                            <CodeHighlight
                                code={JSON.stringify(t.description, null, 2) ?? ""}
                                language="json"
                                copyLabel="Copy button code"
                                copiedLabel="Copied!"
                            />
                        </ScrollArea.Autosize>
                    </Stack>
                </Timeline.Item>
            ))}
        </Timeline>
    );
};
